import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import './../../assets/styles/family-chart.css';
import f3 from './../../FamilyTree/index.js';
import InviteAction from './../App/InviteAction';
import { API_BASE_URL,HOST_NAME } from '../../constants.js';
import UpdatePopup from "./UpdatePopup";
import TopLeftHeart from "./TopLeftHeart";

import axios from 'axios';

const DEFAULT_USER_ID = '09203910-0dd0-426d-8e80-1d30c9b54ab4';

function customAddBtn(card_dim) {
  return (`
    <g class="customAddBtn" style="cursor: pointer">
      <g transform="translate(${card_dim.w - 12},${card_dim.h - 12})scale(.08)">
        <circle r="100" fill="#fff" />
        <g transform="translate(-50,-45)">
          <line x1="10" x2="90" y1="50" y2="50" stroke="currentColor" stroke-width="20" stroke-linecap="round" />
          <line x1="50" x2="50" y1="10" y2="90" stroke="currentColor" stroke-width="20" stroke-linecap="round" />
        </g>
      </g>
    </g>
  `);
}
function customAddBtnListener(store, props) {}
function getYear(dob) {
  if (!dob) return '';

  const parts = dob.split('-');
  if (parts.length !== 3) return '';

  // If first part has 4 digits → YYYY-MM-DD
  if (parts[0].length === 4) {
    return parts[0];
  }

  // Else assume DD-MM-YYYY
  if (parts[2].length === 4) {
    return parts[2];
  }

  return '';
}

function cardDisplay() {
  const d1 = d => `${d.data['first_name'] || ''} ${d.data['last_name'] || ''}`;
  const d2 = d => {
    const dob = d.data['dob'] || '';
    const dod = d.data['dod'] || '';

    const birthYear = getYear(dob)
;
    const deathYear = getYear(dod)
    if (birthYear) {
      return `${birthYear} - ${deathYear || ''}`;
    }

    return '';
  };  const d3 = d => {
    if (d.data['last_login'] === null && d.data['mobile'] && d.data['authenticated'] === 'N') {
      return 'invite';
    } else {
      return '';
    }
  };
  d1.create_form = "{first_name} {last_name}";
  d2.create_form = "{dob}-{dod}";
  d3.create_form = "invite";
  return [d1, d2, d3];
}
let ws = null; 

function FamilyTree() {
  const { userId, accessToken, refreshToken, refreshTree } = useParams();
  const axiosAppInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Authorization: accessToken ? 'JWT ' + accessToken : null,
      'Content-Type': 'application/json',
      accept: 'application/json'
    },
  });

  axiosAppInstance.interceptors.response.use(
    (response) => response,
    async function (error) {
      const originalRequest = error.config;
      if (typeof error.response === 'undefined') {
        alert('A server/network error occurred. Sorry about this.');
        return Promise.reject(error);
      }
      if (error.response.status === 401 && originalRequest.url === '/token/refresh/') {
        window.location.href = '/login/';
        return Promise.reject(error);
      }
      if (
        (error.response.data.code === 'token_not_valid' || error.response.data.errors?.code === 'token_not_valid') &&
        error.response.status === 401 &&
        error.response.statusText === 'Unauthorized'
      ) {
        if (refreshToken) {
          const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));
          const now = Math.ceil(Date.now() / 1000);
          if (tokenParts.exp > now) {
            return axiosAppInstance
              .post('/token/refresh/', { refresh: refreshToken })
              .then((response) => {
                axiosAppInstance.defaults.headers['Authorization'] = 'JWT ' + response.data.access;
                originalRequest.headers['Authorization'] = 'JWT ' + response.data.access;
                return axiosAppInstance(originalRequest);
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.log('Refresh token is expired', tokenParts.exp, now);
          }
        } else {
          console.log('Refresh token not available.');
        }
      }
      return Promise.reject(error);
    }
  );
  
  const familyChartRef = useRef(null);
  // kept for compatibility with original code, not used further
  const [, setData] = useState(null);
  const defaultUserId = userId || DEFAULT_USER_ID;
  const toRefreshTree = refreshTree === "true";
  const router_url = `responsive-tree/${defaultUserId}/${toRefreshTree}`;
  
  const [isModalOpen, setModalOpen] = useState(false);
  const [mobile, setmobile] = useState('');
  const [memberFamilyName, setMemberFamilyName] = useState("");
  const [isExistingBefore, setIsExistingBefore] = useState(false);
  const color_obj = { "#CCFFCC": false, "#FFFFCC": false, "#E6CCFF": false, "#CC6677": false, "#FFCCDD": false };
  const existingMember = {};
  const [bg_color_body, setBgColor] = useState('none');
  const [storeValue, setStoreValue] = useState('');
  const [fitTree, setFitTree] = useState(false);
  const [members, setMembers] = useState([]); // canonical plain-JSON state
  const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
  const [DownloadSubscriber,setDownloadSubscriber]= useState(false);
  const membersRef = useRef([]);

  var memberId = null;
const [male_color, setMaleColor] = useState('#dde8fe');
const [female_color, setFemaleColor] = useState('#fae6ff');
const [font_size , setFontSize] = useState(15);
const [font_color , setFontColor] = useState("#000000");
const [backgroundImageUrl, setBackgroundImageUrl] = useState("");
const [font_family, setFontFamily] = useState("Arial"); // example default
  // var isBefore = true;
  var relationshipNavigator = false;
  var subscriber = false;
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [showList, setShowList] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [lockedBy, setLockedBy] = useState(null);
  const [showHeart,setShowHeart]=useState(false);
  const [anniversaryMemberIds, setAnniversaryMemberIds] = useState([]);

  const lockRef = useRef({ isLocked, lockedBy });

  const closeModal = () => setModalOpen(false);

  function parseGetStorageMemberId() {
    try {
      const raw = localStorage.getItem('GetStorage');
      if (!raw) return '';
      const parsed = JSON.parse(raw);
      return parsed['member_id'] || '';
    } catch (e) {
      console.error("Error parsing GetStorage from localStorage:", e);
      return '';
    }
  }

useEffect(() => {
  window.getQualifyingPages = (jsonData) => {
    try {
      const parsedData = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
      let members;
      if (Array.isArray(parsedData)) {
        members = parsedData;
      } else if (parsedData && Array.isArray(parsedData.members)) {
        members = parsedData.members;
      } else if (parsedData && parsedData.data) {
        members = parsedData.data;
      } else {
        members = parsedData;
      }

      const byId = Object.fromEntries(members.map((m) => [m.id, m]));
      const seenUnits = new Set();
      const qualifyingFocusIds = [];

      members.forEach((m) => {
        const spouseIds = (m.rels?.spouses || []).filter(
          (id) => !(m.hidden_spouses || []).includes(id)
        );
        const fatherId = m.rels?.father || null;
        const motherId = m.rels?.mother || null;
        const childIds = m.rels?.children || [];

        const hasParents = !!(fatherId || motherId);
        const hasChildren = childIds.length > 0;
        const hasSpouse = spouseIds.length > 0;

        if (!hasParents || !hasChildren || !hasSpouse) return;

        const unitKey = [m.id, ...spouseIds].sort().join("-");
        if (seenUnits.has(unitKey)) return;
        seenUnits.add(unitKey);

        qualifyingFocusIds.push(m.id);
      });

      const pages = qualifyingFocusIds.map((focusId) => {
        const m = byId[focusId];
        const spouseIds = (m.rels?.spouses || []).filter(
          (id) => !(m.hidden_spouses || []).includes(id)
        );
        const fatherId = m.rels?.father || null;
        const motherId = m.rels?.mother || null;
        const childIds = m.rels?.children || [];

        const relevantIds = new Set([
          m.id,
          ...(fatherId ? [fatherId] : []),
          ...(motherId ? [motherId] : []),
          ...spouseIds,
          ...childIds,
        ]);

        const subtreeMembers = members
          .filter((mem) => relevantIds.has(mem.id))
          .map((mem) => {
            const cloned = JSON.parse(JSON.stringify(mem));
            if (!cloned.rels) return cloned;

            if (cloned.rels.father && !relevantIds.has(cloned.rels.father)) {
              cloned.rels.father = null;
            }
            if (cloned.rels.mother && !relevantIds.has(cloned.rels.mother)) {
              cloned.rels.mother = null;
            }

            if (childIds.includes(cloned.id)) {
              cloned.rels.children = [];
            } else if (Array.isArray(cloned.rels.children)) {
              cloned.rels.children = cloned.rels.children.filter((id) => relevantIds.has(id));
            }

            if (Array.isArray(cloned.rels.spouses)) {
              cloned.rels.spouses = cloned.rels.spouses.filter((id) => relevantIds.has(id));
            }
            if (Array.isArray(cloned.rels.siblings)) {
              cloned.rels.siblings = [];
            }

            return cloned;
          });

        // build the focus member's display name from data.first_name / last_name
        // build the focus member's display name from data.first_name / last_name
        const firstName = m.data?.first_name || "";
        const lastName = m.data?.last_name || "";
        const focusPersonName = `${firstName} ${lastName}`.trim();

        // build spouse name(s) the same way, using the already-filtered spouseIds
        const spouseNames = spouseIds
          .map((spouseId) => byId[spouseId])
          .filter(Boolean)
          .map((spouse) => {
            const sFirst = spouse.data?.first_name || "";
            const sLast = spouse.data?.last_name || "";
            return `${sFirst} ${sLast}`.trim();
          })
          .filter((name) => name.length > 0);

        const focusMemberName = spouseNames.length > 0
          ? `${focusPersonName} - ${spouseNames.join(" & ")}`
          : focusPersonName;

        return {
          focus_id: focusId,
          focus_member_name: focusMemberName,
          members: subtreeMembers,
        };
      });

      return JSON.stringify(pages);
    } catch (err) {
      console.error("Invalid JSON from Flutter (getQualifyingPages):", err);
      return JSON.stringify({ error: err.message });
    }
  };

  return () => {
    delete window.getQualifyingPages;
  };
}, []);

  // buildFamilyTree always works on a deep clone to avoid polluting state
  const buildFamilyTree = (responseData,anniversaryMemberIds=[]) => {
    if (!responseData || responseData.length === 0) return;
    let safeData;
    try {
      safeData = JSON.parse(JSON.stringify(responseData));
    } catch (err) {
      // if stringify fails for any reason, fall back to shallow clone (best-effort)
      safeData = responseData.map(m => ({
        id: m.id,
        data: { ...(m.data || {}) },
        rels: { ...(m.rels || {}) },
        main: m.main,
        owner: m.owner,
        hidden_spouses: m.hidden_spouses || []
      }));
    }

    console.log("###########################################################################");
    console.log(safeData);

    const card_dim = { w: 220, h: 70, text_x: 75, text_y: 15, img_w: 60, img_h: 60, img_x: 5, img_y: 5 };
    const card_display = cardDisplay();

    // create store with cloned data
    const store = f3.createStore({
      data: safeData,
      backupStash: [],
      node_separation: 250,
      level_separation: 150,
      siblingNodes:[],
      spouseNodeId:anniversaryMemberIds
    });

    setStoreValue(store);

    const view = f3.d3AnimationView({
      store,
      cont: document.querySelector("#FamilyChart"),
      bg_color: bg_color_body,
      backgroundImageUrl: backgroundImageUrl,
      fitTree: fitTree
    });

    const Card = f3.elements.Card({
      store,
      svg: view.svg,
      card_dim,
      card_display,
      mini_tree: true,
      link_break: false,
      hide_rels: true,
      node_separation: 250,
      level_separation: 150,
      cardEditForm,
      custom_elements: [{ el: customAddBtn(card_dim), lis: customAddBtnListener, query: ".customAddBtn" }],
      addRelative: AddRelative,
      deleteMember: DeleteMember,
      makeAdmin: MakeAdmin,
      imageClicked:ImageClicked,
      colors: color_obj,
      existingMember: existingMember,
      family_id: "",
      member_count: safeData.length,
      font_family: font_family,
      male_color: male_color,
      female_color: female_color,
      font_size: font_size,
      font_color: font_color,
      isBefore: isExistingBefore,
      module: "tree",
      fitTree: fitTree,
      relationshipNavigator: relationshipNavigator,
      lockRef:lockRef,
      loggedInMember:memberId
    });

    view.setCard(Card);
    store.setOnUpdate((props) => view.update(props || {}));
    store.update.tree({ initial: true });
   
  };
useEffect(() => {
  lockRef.current = { isLocked, lockedBy };
}, [isLocked, lockedBy]);

useEffect(() => {
  window.updateMemberInTree = (payload) => {
    try {
      console.log("received payload......")
      console.log(payload)
      const { member_details } = payload;

      if (!member_details || !member_details.member) {
        throw new Error("Invalid payload: member_details missing");
      }
      const newMemberId = member_details.member;

      const url = new URL(window.location);
      const segments = url.pathname.split("/");
      segments[2] = newMemberId;

      url.pathname = segments.join("/");

      window.history.replaceState({}, "", url);

      setMembers((prevTree) => {
        const updatedTree = prevTree.map((node) => {
          if (node.id === member_details.member) {
            const updatedData = { ...node.data };

            Object.keys(member_details).forEach((key) => {
              if (key in updatedData) {
                updatedData[key] = member_details[key];
              }
            });

            return { ...node, data: updatedData };
          }
          return node;
        });
        return updatedTree;
      });

    } catch (err) {
      console.error("Update error:", err);
    }
  };
}, []);


const initWebSocket = (memberId) => {
  const member_id = memberId || defaultUserId;

  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const wsUrl = `${protocol}://${HOST_NAME}/ws/presence/${member_id}/`;

  ws = new WebSocket(wsUrl);

  ws.onopen = () => console.log(`✅ WebSocket connected for member ${member_id}`);

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      // Get current member info
      const myMember = membersRef.current.find(m => m.id === member_id);
      // --- Handle online update ---
      if (data.type === "online_update") {
        const filteredUsers = myMember.id
          ? data.users.filter(
              u => u.member_id !== myMember.id
            )
          : data.users;

        console.log("Online users:", filteredUsers);
        setOnlineUsers(filteredUsers);
      }

      // --- Handle lock button ---
      if (data.type === "lock_add_button") {
        const { locked_by, locked_member_id } = data;

        const buttons = Array.from(document.querySelectorAll(".card_add_relative"))
          .filter(btn => !btn.classList.contains("disabled"));

        if (buttons.length > 0) {
          if (locked_member_id !== member_id) {
            setIsLocked(true);
            setLockedBy(locked_by);

            buttons.forEach(btn => {
              btn.classList.add("disabled");
              btn.style.cursor = "not-allowed";
              btn.style.opacity = "0.5";
            });
          } else {
            setIsLocked(false);
            setLockedBy(null);
          }
        }
      }

      // --- Handle unlock button ---
      if (data.type === "unlock_add_button" && data.unlocked_member_id!=member_id) {
        setIsLocked(false);
        setLockedBy(null);

        document.querySelectorAll(".card_add_relative").forEach(btn => {
          btn.classList.remove("disabled");
          btn.style.pointerEvents = "auto";
          btn.style.opacity = "1";
          btn.style.cursor = "pointer";
        });
        window.location.reload()
      }

    } catch (err) {
      console.error("⚠️ Error parsing WebSocket message:", err);
    }
  };

  ws.onclose = () => console.log("❌ WebSocket disconnected");

  return () => ws.close();
};

useEffect(() => {
  membersRef.current = members;
}, [members]);

  const fetchDataAndUpdate = useCallback(async (mainId) => {
    try {
      try {
          let cookie_main_id = mainId || defaultUserId;
          await axiosAppInstance.get(API_BASE_URL + "user-settings/" + cookie_main_id)
          .then((response) => {
            if (response && response.data) {
              console.log("I am the response data..........")
              console.log(response.data.data)
              if( response.data.data.font_family) setFontFamily(response.data.data.font_family)
              if(response.data.data.background_pic) setBackgroundImageUrl(response.data.data.background_pic)
              if (response.data.data.male_color) setMaleColor(response.data.data.male_color);
              if (response.data.data.female_color) setFemaleColor(response.data.data.female_color);
              if(response.data.data.bg_color)setBgColor(response.data.data.bg_color)
              let app_version=response.data.data.app_version?response.data.data.app_version:null;
              const urlParams = new URLSearchParams(window.location.search);

              if(!backgroundImageUrl){
                setBgColor(response.data.data.bg_color || bg_color_body);
                if(response.data.data.bg_color)setBgColor(response.data.data.bg_color)
              }
              
              if(response.data.data.font_size)setFontSize(response.data.data.font_size) 
              if(response.data.data.font_color)setFontColor(response.data.data.font_color)
              if(response.data.data.font_name && response.data.data.font_family_id && response.data.data.font_family_id==15)setFontFamily(response.data.data.font_name)
              let visibilityControl = response.data?.data?.visibility_control || {};
              subscriber = visibilityControl["subscriber"] ?? false;
              if(response.data.data.is_download_subscriber)setDownloadSubscriber(response.data.data.is_download_subscriber)
              setFitTree(visibilityControl["subscriber"] ?? false);
              relationshipNavigator=visibilityControl["Relationship Navigator"] ?? false;
            }
          });
      }
      catch (error) {
        console.log(error);
      }

      console.log("I am from api call..........");
      const response = await axiosAppInstance.get(router_url);
      const responseData = response.data.data || [];
      // console.log("received from api............");
      // console.log(responseData);
      if(responseData.length>25) setFitTree(true);
      setMembers(responseData);
      try {
            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
              await window.flutter_inappwebview.callHandler(
                'treeWithUpdatedJson',       
                JSON.stringify(responseData) 
              );
            }
          } catch (error) {
            console.error('Error calling Flutter method:', error);
          }
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
      try {
        let cookie_main_id = mainId || defaultUserId;
      console.log(cookie_main_id)
      // 1️⃣ Get member-family using search=id
      const memberFamilyRes = await axiosAppInstance.get(
        `${API_BASE_URL}member-family/?search=${cookie_main_id}`
      );
      console.log(memberFamilyRes)
      const familyList = memberFamilyRes.data?.data || [];

      if (!familyList.length) {
        console.warn("No family found for this member.");
        return;
      }

      // 2️⃣ Extract family_id
      const family_id = familyList[0].family;
      console.log("Found family_id:", family_id);

      // 3️⃣ Get event details
      const eventRes = await axiosAppInstance.get(
        `${API_BASE_URL}event-details?family_id=${family_id}`
      );

      const eventDetails = eventRes.data?.data || [];
      const today = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"

      const anniversaryList = [];

      eventDetails.forEach(ev => {
        if (ev.event_type === "A") {
          const eventDate = ev.start_datetime?.slice(0, 10);

          if (eventDate === today) {
            setShowHeart(true);
            anniversaryList.push(ev.member_id);
            anniversaryList.push(ev.rel_member_id);
          }
        }
      });

      console.log(anniversaryList)
      setAnniversaryMemberIds(anniversaryList);
      console.log("Event details:", eventDetails);

    // OPTIONAL: pass eventDetails to your UI or store
    // setEventDetails(eventDetails); ← if you have state
  } catch (err) {
    console.error("Error while loading family/events:", err);
  }
  }, [router_url]);

  useEffect(() => {
    window.buildTreeFromFlutter = (jsonData) => {
      try {
        const parsedData = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
        if (Array.isArray(parsedData)) {
          setMembers(parsedData);
        } else if (parsedData && Array.isArray(parsedData.members)) {
          setMembers(parsedData.members);
        } else if (parsedData && parsedData.data) {
          setMembers(parsedData.data);
        } else {
          setMembers(parsedData);
        }
      } catch (err) {
        console.error("Invalid JSON from Flutter:", err);
      }
    };

    return () => {
      delete window.buildTreeFromFlutter;
    };
  }, []);
window.closeAddPopup = () => {
    if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({ action: "unlock_add_button" }));
    console.log("Sent unlock_add_button via WebSocket");
  } else {
    console.warn("WebSocket not ready, could not send unlock_add_button");
  }
}
 useEffect(() => {
  window.addMemberFromFlutter = (newJson) => {
    if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({ action: "unlock_add_button" }));
    console.log("Sent unlock_add_button via WebSocket");
  } else {
    console.warn("WebSocket not ready, could not send unlock_add_button");
  }
    const incomingMembers = newJson.members || [];
      let updatedTree = [];
    if (incomingMembers.length === 0) return;

    setMembers((prevMembers) => {
      const updated = [...prevMembers];
      updatedTree = updated;
      const findMember = (id) =>
        updated.find((m) => m.id === id || m.data?.old_id === id);

      incomingMembers.forEach((incoming) => {
        const newId = crypto.randomUUID();

        const newNode = {
          id: newId,
          data: {
            ...incoming,
            old_id: incoming.memberID || incoming.id || null,
            is_active: true,
            user_permissions: [],
            groups: [],
            last_login: null,
            is_superuser: false,
            is_admin: false,
            relogin_required: false,
            date_joined: new Date().toISOString(),
            is_existing_member: false,
            order_id: 0,
            existing_member_id: null,
            profile_pic_raw_url: incoming.profile_pic || "",
            is_authenticated: "N",
          },
          rels: { father: null, mother: null, spouses: [], children: [], siblings: [],pets:[] },
          main: false,
          owner: null,
          hidden_spouses: [],
        };

        updated.push(newNode);
        incoming.memberID = newId;
        if (incoming.associated_member) {
          const associated = findMember(incoming.associated_member);
          if (associated) {
            const relation = (incoming.relationship || "").toLowerCase();

          if (["brother", "sister"].includes(relation)) {
                if (!associated.rels.siblings.includes(newId))
                  associated.rels.siblings.push(newId);
                if (!newNode.rels.siblings.includes(associated.id))
                  newNode.rels.siblings.push(associated.id);

                const father = associated.rels.father && findMember(associated.rels.father);
                const mother = associated.rels.mother && findMember(associated.rels.mother);

                const parents = [];
                if (father) parents.push(father);
                if (mother) parents.push(mother);

                parents.forEach((parent) => {
                  if (parent.id === father?.id) {
                    newNode.rels.father = father.id;
                  }
                  if (parent.id === mother?.id) {
                    newNode.rels.mother = mother.id;
                  }

                  if (!parent.rels.children.includes(newId)) {
                    parent.rels.children.push(newId);
                  }

                  if (
                    incoming.another_parent &&
                    parent.rels.spouses &&
                    parent.rels.spouses.length > 1
                  ) {
                    const anotherParent = findMember(incoming.another_parent);
                    if (
                      anotherParent &&
                      !anotherParent.rels.children.includes(newId)
                    ) {
                      anotherParent.rels.children.push(newId);

                      if (
                        anotherParent.id !== newNode.rels.father &&
                        anotherParent.id !== newNode.rels.mother
                      ) {
                        if (!newNode.rels.father) {
                          newNode.rels.father = anotherParent.id;
                        } else if (!newNode.rels.mother) {
                          newNode.rels.mother = anotherParent.id;
                        }
                      }
                    }
                  }

                  parent.rels.children.forEach((childId) => {
                    if (childId !== newId) {
                      const sibling = findMember(childId);
                      if (sibling && !sibling.rels.siblings.includes(newId)) {
                        sibling.rels.siblings.push(newId);
                      }
                      if (!newNode.rels.siblings.includes(childId)) {
                        newNode.rels.siblings.push(childId);
                      }
                    }
                  });
                });
              }

           else if (["son", "daughter", "child"].includes(relation)) {
                    if (!associated.rels.children.includes(newId)) {
                      associated.rels.children.push(newId);
                    }
                    if ((associated.data.gender || "").toLowerCase() === "male" || associated.data.gender=='M') {
                      newNode.rels.father = associated.id;
                    } else if ((associated.data.gender || "").toLowerCase() === "female"|| associated.data.gender=='F') {
                      newNode.rels.mother = associated.id;
                    }

                    const spouses = associated.rels.spouses || [];
                    const anotherParentId = incoming?.another_parent;

                    if (spouses.length > 0) {
                      if (anotherParentId) {
                        const spouse = findMember(anotherParentId);

                        if (spouse) {
                          if (!spouse.rels.children.includes(newId)) {
                            spouse.rels.children.push(newId);
                          }

                          const gender = (spouse.data.gender || "").toLowerCase();
                          if (gender === "male" || spouse.data.gender === "M") {
                            newNode.rels.father = spouse.id;
                          } else if (gender === "female" || spouse.data.gender === "F") {
                            newNode.rels.mother = spouse.id;
                          }
                        }
                      } else {
                        spouses.forEach((spouseId) => {
                          const spouse = findMember(spouseId);
                          if (spouse) {
                            if (!spouse.rels.children.includes(newId)) {
                              spouse.rels.children.push(newId);
                            }

                            const gender = (spouse.data.gender || "").toLowerCase();
                            if (gender === "male" || spouse.data.gender === "M") {
                              newNode.rels.father = spouse.id;
                            } else if (gender === "female" || spouse.data.gender === "F") {
                              newNode.rels.mother = spouse.id;
                            }
                          }
                        });
                      }
                    }


                    associated.rels.children.forEach((existingChildId) => {
                      if (existingChildId !== newId) {
                        const existingChild = findMember(existingChildId);
                        if (existingChild) {
                          if (!existingChild.rels.siblings.includes(newId)) {
                            existingChild.rels.siblings.push(newId);
                          }
                          if (!newNode.rels.siblings.includes(existingChildId)) {
                            newNode.rels.siblings.push(existingChildId);
                          }
                        }
                      }
                    });
            }
          else if (relation === "father") {
              associated.rels.father = newId;

              if (!newNode.rels.children.includes(associated.id)) {
                newNode.rels.children.push(associated.id);
              }

              if (associated.rels.mother) {
                const mother = findMember(associated.rels.mother);

                if (mother) {
                  if (!newNode.rels.spouses.includes(mother.id)) {
                    newNode.rels.spouses.push(mother.id);
                  }
                  if (!mother.rels.spouses.includes(newId)) {
                    mother.rels.spouses.push(newId);
                  }

                  mother.rels.children.forEach((childId) => {
                    const child = findMember(childId);
                    if (child && !newNode.rels.children.includes(childId)) {
                      newNode.rels.children.push(childId);
                    }
                    if (child && !child.rels.father) {
                      child.rels.father = newId;
                    }
                  });
                }
              }

          } else if (relation === "mother") {
            associated.rels.mother = newId;

            if (!newNode.rels.children.includes(associated.id)) {
              newNode.rels.children.push(associated.id);
            }

            if (associated.rels.father) {
              const father = findMember(associated.rels.father);

              if (father) {
                if (!newNode.rels.spouses.includes(father.id)) {
                  newNode.rels.spouses.push(father.id);
                }
                if (!father.rels.spouses.includes(newId)) {
                  father.rels.spouses.push(newId);
                }

                father.rels.children.forEach((childId) => {
                  const child = findMember(childId);
                  if (child && !newNode.rels.children.includes(childId)) {
                    newNode.rels.children.push(childId);
                  }
                  if (child && !child.rels.mother) {
                    child.rels.mother = newId;
                  }
                    });
                  }
                }
              }
           else if (["husband", "wife"].includes(relation)) {
              if (!associated.rels.spouses.includes(newId)) {
                associated.rels.spouses.push(newId);
              }
              if (!newNode.rels.spouses.includes(associated.id)) {
                newNode.rels.spouses.push(associated.id);
              }

            if (associated.rels.children && associated.rels.children.length > 0) {
              const spouses = associated.rels.spouses || [];

              // ✅ Proceed only if associated has zero or one spouse
              if (spouses.length <= 1) {
                associated.rels.children.forEach((childId) => {
                  const child = findMember(childId);
                  if (child) {
                    if (!newNode.rels.children.includes(childId)) {
                      newNode.rels.children.push(childId);
                    }

                    const gender = (newNode.data.gender || "").toLowerCase();
                    if ((gender === "male" || newNode.data.gender === "M") && !child.rels.father) {
                      child.rels.father = newId;
                    } else if ((gender === "female" || newNode.data.gender === "F") && !child.rels.mother) {
                      child.rels.mother = newId;
                    }
                  }
                });
              }
            }


            }
            else if (relation === "pet") {
            // Link the pet to its owner via the dedicated `owner` field
            newNode.owner = associated.id;

            // Track it on the owner's side too, without touching children/siblings
            if (!associated.rels.pets) associated.rels.pets = [];
            if (!associated.rels.pets.includes(newId)) {
              associated.rels.pets.push(newId);
            }

            // Optional: flag it for rendering so your tree UI can style pets differently
            newNode.data.is_pet = true;
          }

          }
          
          else {
            console.warn("Associated member not found locally:", incoming.associated_member);
          }
        }
      });

      return updated;
    });
    return { newJson, updatedTree };
  };

window.deleteMemberFromFlutter = (memberId) => {
  let deleted = false;
  let dependents = [];

  setMembers((prevMembers) => {
    const updated = [...prevMembers];
    const findMember = (id) =>
      updated.find((m) => m.id === id || m.data?.old_id === id);

    const member = findMember(memberId);
    if (!member) return prevMembers;

    const memberName = [member.data?.first_name, member.data?.middle_name, member.data?.last_name]
      .filter(Boolean)
      .join(" ");

    const hasParent = member.rels.father || member.rels.mother;
    const hasChild = member.rels.children.length > 0;
    const hasMultipleChildren = member.rels.children.length > 1;
    const hasSpouse = member.rels.spouses.length > 0;

    const buildDependentInfo = (id, relation) => {
      const m = findMember(id);
      if (!m) return null;
      const { first_name, middle_name, last_name } = m.data || {};
      const fullName = [first_name, middle_name, last_name]
        .filter(Boolean)
        .join(" ");
      return {
        name: memberName,
        relation,
        message: `${fullName} is ${relation} of ${memberName}. Delete ${fullName} first.`,
        memberId: m.id || m.data?.old_id,
      };
    };

    if (hasParent && hasChild) {
      dependents = [
        ...member.rels.children.map((id) => buildDependentInfo(id, "child")),
        buildDependentInfo(member.rels.father, "father"),
        buildDependentInfo(member.rels.mother, "mother"),
      ].filter(Boolean);
      return prevMembers;
    }

    if (hasMultipleChildren && !hasSpouse) {
      dependents = member.rels.children
        .map((id) => buildDependentInfo(id, "child"))
        .filter(Boolean);
      return prevMembers;
    }

    if (hasParent && hasSpouse) {
      dependents = [
        ...member.rels.spouses.map((id) => buildDependentInfo(id, "spouse")),
        buildDependentInfo(member.rels.father, "father"),
        buildDependentInfo(member.rels.mother, "mother"),
      ].filter(Boolean);
      return prevMembers;
    }

    updated.forEach((m) => {
      m.rels.spouses = m.rels.spouses.filter((id) => id !== memberId);
      m.rels.children = m.rels.children.filter((id) => id !== memberId);
      m.rels.siblings = m.rels.siblings.filter((id) => id !== memberId);
      if (m.rels.father === memberId) m.rels.father = null;
      if (m.rels.mother === memberId) m.rels.mother = null;
    });

    const idx = updated.findIndex((m) => m.id === memberId);
    if (idx !== -1) {
      updated.splice(idx, 1);
      deleted = true;
    }

    return updated;
  });

  if (!deleted) {
    return { status: "blocked", dependents };
  } else {
    return { status: "deleted" };
  }
};

window.updateOrderIdAndRender = ({ order_id }) => {
  console.log("New order:", order_id);

  setMembers((prevMembers) => {
    const updated = prevMembers.map((m) => ({
      ...m,
      rels: { ...m.rels },
      data: { ...m.data },
    }));

    order_id.forEach((memberId, index) => {
      const node = updated.find(
        (m) => m.id === memberId || m.data?.old_id === memberId
      );
      if (node) {
        node.data.order_id = index + 1;
      }
    });

    if (order_id.length > 0) {
      const firstMember = updated.find(
        (m) => m.id === order_id[0] || m.data?.old_id === order_id[0]
      );
      if (firstMember) {
        const parentId = firstMember.rels.father || firstMember.rels.mother;
        if (parentId) {
          const parent = updated.find(
            (m) => m.id === parentId || m.data?.old_id === parentId
          );
          if (parent) {
            parent.rels.children = order_id.filter((id) =>
              parent.rels.children.includes(id)
            );
          }
        }
      }
    }

    return updated;
  });

  return true;
};

  return () => {
    delete window.addMemberFromFlutter;
    delete window.deleteMemberFromFlutter;
    delete window.updateOrderIdAndRender;
  };
}, []);


  useEffect(() => {
    if (members && members.length > 0) {
      try {
        const safeCopy = JSON.parse(JSON.stringify(members));
        buildFamilyTree(safeCopy);
      } catch (err) {
        const fallback = members.map(m => ({
          id: m.id,
          data: { ...(m.data || {}) },
          rels: { ...(m.rels || {}) },
          main: m.main,
          owner: m.owner,
          hidden_spouses: m.hidden_spouses || []
        }));
        buildFamilyTree(fallback);
      }
    }
  }, [members]);

  useEffect(() => {
    async function fetchMemberId() {
      try {
        if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
          memberId = await window.flutter_inappwebview.callHandler('getLocalStorageData', 'login_member_id');
        }
      } catch (error) {
        console.error('Flutter handler error:', error);
      }

      if (!memberId) {
        memberId = parseGetStorageMemberId();
      }
      await fetchDataAndUpdate(memberId || "");
      initWebSocket(memberId || "");
    }

    fetchMemberId();
  }, [fetchDataAndUpdate]);

  const handleInviteAction = () => {
    closeModal();
  };
  const handleCancel = () => {
    closeModal();
  };
  const handleInputChange = (event) => {
    const { value } = event.target;
    setmobile(value);
  };
  const handleFamilyNameChange = (event) => {
    const { value } = event.target;
    setMemberFamilyName(value);
  };

  return (
    <>
      <div id="toast-container" style={{ display: 'none' }}></div>
      <div id="FamilyChart" ref={familyChartRef} className="family-chart-container"></div>
      <InviteAction
        isOpen={isModalOpen}
        onClose={closeModal}
        onInviteAction={handleInviteAction}
        onCancel={handleCancel}
        mobile={mobile}
        onInputChange={handleInputChange}
        familyChartElement={familyChartRef.current}
        memberFamilyName={memberFamilyName}
        accessToken={accessToken}
        refreshToken={refreshToken}
        axiosAppInstance={axiosAppInstance}
        isBefore={isExistingBefore}
        storeValue={storeValue}
        fitTree={fitTree}
        DownloadSubscriber={DownloadSubscriber}
      />
       <TopLeftHeart
       floating={true}
       visible={showHeart}
       buildFamilyTree={buildFamilyTree}
       members={members}
       anniversaryMemberIds={anniversaryMemberIds}
        />
    <UpdatePopup
  isOpen={isUpdatePopupOpen}
  onUpdate={() => {
    setIsUpdatePopupOpen(false);
  }}
/>

<div
  style={{
    position: "fixed",
    bottom: "10px",
    left: "10px",
    zIndex: 9999,
  }}
>
  <div
    onClick={() => setShowList(!showList)}
    style={{
      padding: "4px 4px",
      background: isLocked ? "#d9534f" : "#0b8ab7",
      border: "1px solid #ccc",
      fontSize: "10px",
      color: "#fff",
      borderRadius: "6px",
      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.1)",
      cursor: "pointer",
      minWidth: "125px",
      textAlign: "left",
      transition: "background 0.3s ease",
    }}
  >
    {isLocked ? (
      <>{lockedBy} is adding...</>
    ) : (
      <>Family members online: {onlineUsers.length}</>
    )}
  </div>

  {showList && !isLocked && (
    <div
      style={{
        position: "absolute",
        bottom: "100%",
        left: 0,
        background: "#0b8ab7",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "4px 4px",
        width: "100%",
        color: "#fff",
        fontSize: "10px",
        boxShadow: "0 -2px 6px rgba(0,0,0,0.2)",
        whiteSpace: "pre-wrap",
      }}
    >
      {onlineUsers.length > 0 
  ? onlineUsers.map(u => u.username).join(", ") 
  : "No one online"}

    </div>
  )}
</div>



    </>
  );
}

// // Utility functions (unchanged)
// function AddRelative(props) {
//   const { id } = props.d.data;
//   let has_parents = true;
//   let has_father = false;
//   let has_mother = false;
//   if (props.d.data.rels.father) has_father = true;
//   if (props.d.data.rels.mother) has_mother = true;
//   if (!props.d.data.rels.father && !props.d.data.rels.mother) {
//     has_parents = false;
//   }
//   if (props.isBefore) {
//     const url = `${window.location.href.split('?')[0]}?member_id=${id}&event=add&gender=${props.d.data.data.gender}&relation=unknown&has_parents=${has_parents}&is_admin=${props.d.data.data.is_admin}&has_father=${has_father}&has_mother=${has_mother}&main_member=${window.location.href.split('/')[4]}&name=${props.d.data.data.first_name}&profile_pic=${encodeURIComponent(props.d.data.data.profile_pic_raw_url)}`;
//     window.location.href = url;
//   }
// }

// function DeleteMember(props) {
//   const { id } = props.d.data;
//   if (props.isBefore) {
//     const url = `${window.location.href.split('?')[0]}?member_id=${id}&event=delete`;
//     window.location.href = url;
//   }
// }
// function MakeAdmin(props) {
//   const { id } = props.d.data;
//   if (props.isBefore) {
//     const url = `${window.location.href.split('?')[0]}?member_id=${id}&event=make_admin`;
//     window.location.href = url;
//   }
// }
// function cardEditForm(props) {
//   const currentURL = window.location.href.split('?')[0];
//   const newURL = new URL(currentURL);

//   if (!props || !props.d || !props.d.data) {
//     let { gender } = props.datum.data;
//     if (gender === "F") gender = "M";
//     else if (gender === "M") gender = "F";

//     const { spouses } = props.datum.rels;
//     if (spouses && Array.isArray(spouses) && spouses.length > 0) {
//       const spouse = spouses[0];
//       if (props.isBefore) {
//         newURL.searchParams.append('member_id', spouse);
//         newURL.searchParams.append('event', 'add');
//         newURL.searchParams.append('gender', gender);
//         newURL.searchParams.append('relation', 'spouse');
//         window.location.href = newURL.href;
//       }
//     }
//     return;
//   }

//   const { id } = props.d.data;
//   if (props.isBefore) {
//     newURL.searchParams.append('member_id', id);
//     newURL.searchParams.append('event', 'edit');
//     window.location.href = newURL.href;
//   }
// }
export function sendEventToFlutter(eventType, props, extra = {}) {
  let memberId = props?.d?.data?.id || null;
  let gender = props?.d?.data?.data?.gender || props?.datum?.data?.gender;
  let is_admin = props?.d?.data?.data?.is_admin || false;

  if (!props?.d?.data && props?.datum?.rels?.spouses?.length > 0) {
    memberId = props.datum.rels.spouses[0];
    if (gender === "F") gender = "M";
    else if (gender === "M") gender = "F";
  }

  let has_father = Boolean(props?.d?.data?.rels?.father);
  let has_mother = Boolean(props?.d?.data?.rels?.mother);
  let has_parents = has_father || has_mother;

  const currency = extra?.currency_val?.code || extra?.currency || null;
  const amount = extra?.currency_val?.value || extra?.amount || null;
  const file_name = extra?.file_name || null;
  const mode = extra?.mode || null; // included in payload
  const baseUrl = extra?.baseUrl || window.location.href.split("?")[0];

  const payload = {
    member_id: memberId,
    event: eventType,
    gender,
    is_admin,
    relation: "unknown",
    has_parents,
    has_father,
    has_mother,
    main_member: window.location.href.split("/")[4],
    name: props?.d?.data?.data?.first_name,
    profile_pic: props?.d?.data?.data?.profile_pic_raw_url,
    currency,
    amount,
    file_name,
    mode,
    ...extra,
  };

  console.log("Payload to Flutter / Redirect:", payload);

  if (props.isBefore) {
    const newURL = new URL(baseUrl);

    newURL.searchParams.append("member_id", memberId);
    newURL.searchParams.append("event", eventType);

    if (payload.relation) newURL.searchParams.append("relation", payload.relation);
    if (payload.gender) newURL.searchParams.append("gender", payload.gender);
    newURL.searchParams.append("has_parents", has_parents);
    newURL.searchParams.append("is_admin", is_admin);
    newURL.searchParams.append("has_father", has_father);
    newURL.searchParams.append("has_mother", has_mother);
    newURL.searchParams.append("main_member", payload.main_member);
    if (payload.name) newURL.searchParams.append("name", payload.name);
    if (payload.profile_pic)
      newURL.searchParams.append("profile_pic", encodeURIComponent(payload.profile_pic));

    if (eventType === "trigger_payment") {
      if (currency) newURL.searchParams.append("currency", currency);
      if (amount) newURL.searchParams.append("amount", amount);
    }

    if (eventType === "download" && file_name) {
      newURL.searchParams.append("file_name", file_name);
    }

    // Handle events with mode: bubble_view, map_view, tree_view
    if (["bubble_view", "map_view", "tree_view"].includes(eventType)) {
      newURL.searchParams.append("mode", mode !== null ? mode : 0); // default 0 for tree_view
    }

    // window.location.href = newURL.href;
    return;
  }

  if (window.flutter_inappwebview) {
    console.log("Sending payload to Flutter via memberEvent...");
    window.flutter_inappwebview.callHandler("memberEvent", payload);
  }else {
    console.log("postMessage...................")
    // Web implementation
    window.parent.postMessage({
      name: "memberEvent",
      body: payload
    }, '*');
    console.log(payload)
  }
  
}



function AddRelative(props) {
  console.log("I am the prop.........")
  console.log(props)
   if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ action: "lock_add_button" }));
    }
  sendEventToFlutter("add", props);
}

function DeleteMember(props) {
  sendEventToFlutter("delete", props);
}
function ImageClicked(props) {
  sendEventToFlutter("image_clicked", props);
}
function MakeAdmin(props) {
  sendEventToFlutter("make_admin", props);
}

function cardEditForm(props) {
  if (!props?.d?.data) {
    // spouse add case
    sendEventToFlutter("add", props, { relation: "spouse" });
    return;
  }
  sendEventToFlutter("edit", props);
}

export default FamilyTree;
